import { Button, Image } from "antd";
import axios from "axios";
import { create } from "zustand";

export let useBooks = create((set, get) => ({
    books: [],
    ed: {},
    setEd: (rec) => {
        set({ ed: rec })
    },
    columns: [
        {
            title: 'Rasmi',
            dataIndex: 'img',
            key: 'img',
            width: 100,
            render: (_, rec) => <Image src={rec.img} height={70} />
        },
        {
            title: 'Kitob Nomi',
            dataIndex: 'name',
            key: 'name',
            onFilter: (value, record) => record.name && record.name.toString().toLowerCase().includes(value.toLowerCase()),
            filterSearch: true,
        },
        {
            title: 'Yuklash',
            dataIndex: 'url',
            key: 'url',
            render: (_, rec) => <a href={rec.url} target="_blank"
                rel="noopener noreferrer"><Button type="primary">Yuklash</Button></a>
        },
        {
            title: 'Muallif',
            dataIndex: 'autor',
            key: 'autor',
            onFilter: (value, record) => record.autor && record.autor.toString().toLowerCase().includes(value.toLowerCase()),
            filterSearch: true,
        },
        {
            title: 'Kategoriya',
            dataIndex: 'cat',
            key: 'cat',
            onFilter: (value, record) => record.cat && record.cat.toString().toLowerCase().includes(value.toLowerCase()),
            filterSearch: true,
        },
        {
            title: 'Yili',
            dataIndex: 'year',
            key: 'year',
            onFilter: (value, record) => record.year && record.year.toString().toLowerCase().includes(value.toLowerCase()),
            filterSearch: true,
        },
        {
            title: 'Chop etilgan joy',
            dataIndex: 'joy',
            key: 'joy',
        },
        {
            title: 'Nashriyot',
            dataIndex: 'nashriyot',
            key: 'nashriyot',
        },
        {
            title: 'Tili',
            dataIndex: 'til',
            key: 'til',
        },
        {
            title: "Qo'shimcha ma'lumot",
            dataIndex: 'izoh',
            key: 'izoh',
            width: 400,
            render: (_, rec) => <p style={{ whiteSpace: 'pre-wrap', height: '100px', overflow: 'auto' }}>{rec.izoh}</p>
        },
        {
            title: 'Joylangan vaqti',
            dataIndex: 'created_at',
            key: 'created_at',
        },
    ],
    getBooks: () => {
        axios.get('/booksa')
            .then(res => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ books: data });
            })
            .catch(err => {
                console.error('Kitoblarni yuklab olishda xatolik:', err);
                set({ books: [] });
            })
    },
    add: (values) => {
        axios.post('/books', values)
            .then(data => {
                get().getBooks();
            })
            .catch(err => {
                console.error('Kitob qo\'shishda xatolik:', err);
            })
    },
    deleteItem: (_, rec) => {
        axios.delete('books/' + rec.id)
            .then(res => {
                get().getBooks();
            })
            .catch(err => {
                console.error('Kitob o\'chirishda xatolik:', err);
            })
    },
    edit: (values) => {
        axios.put('books/' + get().ed.id, values)
            .then(res => {
                get().getBooks();
            })
            .catch(err => {
                console.error('Kitobni taxrirlashda xatolik:', err);
            })
    }
}))